import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { checkFields } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import { voidDocument } from "../functions/document/voidDocument";

export const voidDocModal = ({
  t,
  setWindowValues,
  setMsg2,
  docValues,
  windowValues,
  closeMsg,
  closeMsgDoc,
  setModalData2,
  logoutAction,
}: stdObject) => {
  return {
    title: t("p.askVoidDoc"),
    label: t("p.thisWillDeleteAllDoc"),
    inputListStyle: { width: "auto" },
    inputs: checkFields.map((e: stdObject) => {
      return {
        label: t(e.label),
        value: windowValues[e.code],
        type: "checkbox",
        style: { width: 300 },
        onChange: (v: { target: { value: SetStateAction<string> } }) =>
          setWindowValues({
            ...windowValues,
            [e.code]: Number(v.target.value) ? 0 : 1,
          }),
      };
    }),
    buttons: [
      {
        label: t("p.void"),
        onClick: () =>
          voidDocument({
            setMsg2,
            docValues,
            windowValues,
            closeMsg,
            closeMsgDoc,
            setModalData2,
            logoutAction,
          }),
        color: colors.red,
      },
      {
        label: t("p.cancel"),
        onClick: () => closeMsg(2),
        color: colors.darkGrey,
      },
    ],
  };
};
